<template>
  <b-card
    no-body
    class=" border border-2 h-100"
  >
    <div class="flex justify-between items-start mb-2 px-1 pt-1">
      <div>
        <div class="font-semibold text-[16px] text-black">
          Payment Method Usage
        </div>
        <div class="text-[#A0A0A0] mt-[3px] text-[12px]">
          Rasio Input vs Output
        </div>
      </div>
      <MonthFilter
        :month.sync="month"
      />
    </div>

    <div class="px-1">
      <div class="border rounded-lg p-1 inline-block mb-2">
        <div class="text-[#A0A0A0] text-[12px] mb-1">
          Total Orders
        </div>
        <div class="text-[22px] leading-none text-black">
          {{ Number(totalOrders).toLocaleString('id-ID') }}
        </div>
      </div>

      <div class="flex flex-col gap-4 w-full">
        <div
          v-for="item in paymentMethods"
          :key="item.key"
          class="flex mb-1 items-center gap-3"
        >
          <div
            class="h-[46px] rounded-md flex items-center px-1 text-white font-medium text-[13px] whitespace-nowrap"
            :style="{ width: item.percentage + '%', minWidth: '140px', backgroundColor: item.color }"
          >
            {{ item.label }}
          </div>
          <div class="text-black font-semibold text-[13px]">
            {{ Number(item.count).toLocaleString('id-ID') }} <span class="text-[#A0A0A0] font-normal">({{ item.percentage }}%)</span>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import moment from 'moment'
import { START_DATE_OF_MONTH, END_DATE_OF_MONTH } from '@/libs/filterDate'
import MonthFilter from './MonthFilter.vue'
import { apiDataPayment } from '../services/api.komchat.service'

export default {
  name: 'PaymentMethodChart',
  components: {
    MonthFilter,
  },
  data() {
    return {
      moment,
      month: moment(),
      totalOrders: 0,
      paymentMethods: [
        {
          key: 'cod', label: 'COD', count: 0, percentage: 0, color: '#F97316',
        },
        {
          key: 'qris', label: 'QRIS', count: 0, percentage: 0, color: '#EA580C',
        },
        {
          key: 'bank_transfer', label: 'Bank Transfer', count: 0, percentage: 0, color: '#C2410C',
        },
        {
          key: 'virtual_account', label: 'Virtual Account', count: 0, percentage: 0, color: '#9A3412',
        },
      ],
    }
  },
  watch: {
    month() {
      this.fetchData()
    },
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      const startDate = START_DATE_OF_MONTH(this.month)
      const endDate = END_DATE_OF_MONTH(this.month)

      try {
        const res = await apiDataPayment({ startDate, endDate })
        if (res && res.data && res.data.data) {
          const { data } = res.data

          let total = 0
          this.paymentMethods.forEach(item => {
            total += (data[item.key] || 0)
          })
          this.totalOrders = total

          this.paymentMethods = this.paymentMethods.map(item => {
            const count = data[item.key] || 0
            const percentage = total > 0 ? Math.round((count / total) * 100) : 0
            return { ...item, count, percentage }
          })
        } else {
          this.totalOrders = 0
          this.paymentMethods = this.paymentMethods.map(item => ({ ...item, count: 0, percentage: 0 }))
        }
      } catch (err) {
        console.error('Failed to fetch payment data', err)
      }
    },
  },
}
</script>
